/* src/app/shared/authentication/components/one-time-code-login/one-time-code-login.component.scss */
.auth .login-form .small-desc {
  padding-bottom: 0;
}
.auth .login-form .desc {
  padding: 0 10px 20px;
}
a.simple-btn.simple-btn-ricon {
  width: 194px;
}
/*# sourceMappingURL=one-time-code-login.component-XQPSZA4S.css.map */
